export default __webpack_public_path__ + "static/media/task.7260f280.svg";